import React from 'react';

import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CalculatorCard = ({ 
  title, 
  description, 
  features, 
  icon, 
  color, 
  estimatedTime, 
  onStart,
  isActive = false 
}) => {
  return (
    <div className={`relative bg-white rounded-xl border-2 transition-all duration-300 ease-out hover:shadow-2xl hover:-translate-y-2 hover:scale-[1.02] focus-within:ring-2 focus-within:ring-secondary focus-within:ring-offset-2 flex flex-col h-full ${
      isActive ? 'border-secondary shadow-elevation scale-105' : 'border-border hover:border-secondary/50'
    }`}>
      {/* Header */}
      <div className="p-6 pb-4">
        <div className="flex items-start justify-between mb-4">
          <div className={`w-12 h-12 rounded-lg flex items-center justify-center transition-transform duration-300 hover:scale-110 hover:rotate-6 ${color}`}>
            <Icon name={icon} size={24} color="white" />
          </div>
          <div className="text-right">
            <div className="text-xs text-muted-foreground font-medium">Est. Time</div>
            <div className="text-sm font-semibold text-primary">{estimatedTime}</div>
          </div>
        </div>
        
        <h3 className="text-xl font-semibold text-primary mb-2">{title}</h3>
        <p className="text-muted-foreground text-sm leading-relaxed">{description}</p>
      </div>
      {/* Features */}
      <div className="px-6 pb-4 flex-1">
        <div className="space-y-2">
          {features?.map((feature, index) => (
            <div key={index} className="flex items-center space-x-2">
              <Icon name="Check" size={16} color="var(--color-secondary)" />
              <span className="text-sm text-foreground">{feature}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Action */}
      <div className="p-6 pt-4 border-t border-border mt-auto">
        <Button
          variant="outline"
          fullWidth
          iconName="Calculator"
          iconPosition="left"
          onClick={onStart}
          className="hover:bg-secondary hover:text-white hover:border-secondary hover:scale-105 hover:shadow-md focus:ring-2 focus:ring-secondary focus:ring-offset-2 active:scale-95 transition-all duration-300"
        >
          Start Calculator
        </Button>
      </div>
      {/* Active Indicator */}
      {isActive && (
        <div className="absolute -top-2 -right-2 w-6 h-6 bg-secondary rounded-full flex items-center justify-center">
          <Icon name="Play" size={12} color="white" />
        </div>
      )}
    </div>
  );
};

export default CalculatorCard;